










































































































































































































































































































































































import { Component, Prop } from 'vue-property-decorator';
import { SwExtendedVue } from '@sonicwall/unified-ui-framework/src/shared/sw-extended-vue';
import UUIFComponent from '@/shared/uuifComponent';
import { SelectOption } from '@sonicwall/unified-ui-framework/src/shared/sw-select';
import { SwExpandableTextfield, SwTextarea } from '@sonicwall/unified-ui-framework/src/shared/sw-textfield';
import { ColumnSortRequestData, SortedColumnInfo, TableColumnConfig,
 TableEntry, TableEntrySelectingEventData } from '@sonicwall/unified-ui-framework/src/shared/sw-table';
import { InfoState } from '@/core/core.store';
import { SwScrollView } from '@sonicwall/unified-ui-framework/src/shared/sw-scroll-view';
import { SwCheckbox } from '@sonicwall/unified-ui-framework/src/shared/sw-checkbox';
import { SwContentToolbar } from '@sonicwall/unified-ui-framework/src/shared/sw-content-toolbar';
import CustomMessagePopup from './../../../shared/custom-message-popup/custom-message-popup.vue';
import { CustomMessagePopupConfig } from '../../../shared/custom-message-popup/types';
import { minLength } from 'vuelidate/lib/validators';
const cssPrefix = 'secureUpdate';

// tslint:disable-next-line
function snoRegexCheck(field : any) {
  const str1 = '(0006B1)[abcdefABCDEF0-9]{6}$';
  const str2 = '(00900b)[abcdefABCDEF0-9]{6}$';
  const str3 = '(0017C5)[abcdefABCDEF0-9]{6}$';
  const str4 = '(CD0000)[abcdefABCDEF0-9]{6}$';
  const str5 = '(18B169)[abcdefABCDEF0-9]{6}$';
  const str6 = '(C0EAE4)[abcdefABCDEF0-9]{6}$';
  const str7 = '(00026F)[abcdefABCDEF0-9]{6}$';
  // tslint:disable-next-line:no-unused
  const str8 = 'FS';
  const str9 = '(0017C3)[abcdefABCDEF0-9]{6}$';
  const str10 = '(SLI080)[abcdefABCDEF0-9]{6}$';
  const str11 = '(BB0000)[abcdefABCDEF0-9]{6}$';
  const str12 = '(CC0000)[abcdefABCDEF0-9]{6}$';
  const str13 = '(004010)[abcdefABCDEF0-9]{6}$';
  // tslint:disable-next-line:no-unused
  const str14 = '(AA0401)[abcdefABCDEF0-9]{6}$';
  const str15 = '(0060F5)[abcdefABCDEF0-9]{6}$';
  const str16 = '(2CB8ED)[abcdefABCDEF0-9]{6}$';
  const str17 = '(F2C784)[abcdefABCDEF0-9]{6}$';
  const str18 = '(18C241)[abcdefABCDEF0-9]{6}$';
  const strArray = [str1 , str2 , str3 , str4 , str5 , str6 , str7 , str9 , str10 , str11 , str12 , str13 , str15 , str16, str17, str18];
  let validSerialNumber: boolean = false;
  strArray.forEach((str) => {
    if (!validSerialNumber) {
      const codeRegex = new RegExp(str.toString()
      .toUpperCase());
      if (codeRegex.test(field?.trim()
      .toString()
      .toUpperCase())) {
        validSerialNumber = true;
      }
    }
  });
  return validSerialNumber;
}

const checkForEmpty = (arr: any) => {
  const requiredInputs = arr?.length > 0 ? arr?.filter((ele: any) => { return ele?.isMandatory === 'True' && ele?.value === ''; }) : [];
  if (requiredInputs?.length > 0) {
    return true;
  }
  return false;
};

@Component({
  components: {
    ...UUIFComponent,
    SwScrollView,
    SwTextarea,
    SwCheckbox,
    SwContentToolbar,
    SwExpandableTextfield,
    CustomMessagePopup,
  },
  validations: {
    answer: {  checkForEmpty, minLength: minLength(3) },
  },
  filters: {
    removeColons: (value: string) => {
      return value?.replace(/[:*]/g, '');
    },
  },
})
export default class SecureUpdate extends SwExtendedVue {
  cssPrefix = cssPrefix;
  @Prop({ required: true })
  secUpdatePage: any;

  @Prop({ required: true })
  secupdateContent: any;

  @Prop({ required : true })
  field : any;
  @Prop()
  serialNumber: any;
  sortedColumns: SortedColumnInfo[] = [];
  answer: { id: string, type: string , value: string, isMandatory: string, regexValidation: string, question: string }[] = [];
  tradeInKey : string = '';
  choiceListOpt: SelectOption[] = [];
  secureRegister: string = '1';
  remoteAnalyser : string = '';
  acceptAcknowledgement: boolean = false;
  TABLE_HEADER_PLUS_EXTRA_HEIGHT: number = 65;
  TABLE_MAX_HEIGHT: number = 95;
  searchInputText : string = '';
  isExpandSearchFilter : boolean = false;
  filterApplied : boolean = false;
  showCustomMessagePopup: boolean =  false;
  customMessagePopupConfig : CustomMessagePopupConfig = {};
  infoText: string = '';
  secureRegisterOptionsArray = [
    {
      id: '1', label: (this.$t('products.registerOnly')
      .toString()), value:'Register only',
    },
    {
      id: '2', label: (this.$t('products.registerTransfer')
      .toString()), value:'Register and transfer',
    },
  ];

  columnConfig : TableColumnConfig[] = [
    {
      key: 'name',
      dataKey: 'name',
      title: (this.$t('products.name_caps')
      .toString()),
      render: (createElement, data: { entry: TableEntry }) => {
        return createElement('div', { class: {
          'truncate-string' : true }, domProps: { innerHTML: data.entry.name, title: data.entry.name } });
      },
      sorter: true,
    },
    {
      key: 'serialnumber',
      dataKey: 'serialnumber',
      title: (this.$t('products.serNum')
      .toString()),
      sorter: true,
    },
    {
      key: 'productline',
      dataKey: 'productline',
      title: (this.$t('products.productLine')
      .toString()),
      sorter: true,
    },
    {
      key: 'expiration',
      dataKey: 'expiration',
      title: (this.$t('products.expiration')
      .toString()),
      sorter: true,
    },
    ...(this.isSMA100TradeUp
      ? [
        {
          key: 'nodeUpgrade',
          dataKey: 'nodeUpgrade',
          title: (this.$t('products.nodeUpgrade')
          .toString()),
          sorter: true,
        },
      ]
      : [
        {
          key: 'registration',
          dataKey: 'registration',
          title: (this.$t('products.registartion')
          .toString()),
          sorter: true,
        },
      ]),
  ];

  columnConfig1 : TableColumnConfig[] = [{
    key: 'name',
    dataKey: 'name',
    title: (this.$t('products.name_caps')
    .toString()),
    render: (createElement, data: { entry: TableEntry }) => {
      return createElement('div', { class: {
        'truncate-string' : true }, domProps: { innerHTML: data.entry.name } });
    },
  },
  {
    key: 'serialnumber',
    dataKey: 'serialnumber',
    title: (this.$t('products.serNum')
    .toString()),
  },
  {
    key: 'productline',
    dataKey: 'productline',
    title: (this.$t('products.productLine')
    .toString()),
  }];

  columnConfigFreeTrail: TableColumnConfig[] = [{
    key: 'friendlyname',
    dataKey: 'frielndlyname',
    title: (this.$t('products.friendlyName')
    .toString()),
    width: 500,
  },
  {
    key: 'serialnumber',
    dataKey: 'serialnumber',
    title: (this.$t('products.serialnumber')
    .toString()),
  }];

  tableData: TableEntry[] = [];
  filteredTableData : TableEntry[] = [];
  closeProductDetail() {
    this.$emit('closeModal');
  }

  get getTableHeight() {
    if (this.secUpdatePage === 'Storage Module') {
      let height: any = '';
      console.warn(this.$route.query.mode);
      if (this.$route.query && this.$route.query.mode === 'APP') {
        height = 'calc(100vh - 37rem)';
      } else {
        height = 'calc(100vh - 47rem)';
      }
      return height;
    }
    // tslint:disable-next-line:max-line-length
    let height = (this.secupdateContent.content.arrTradeInSerials ? this.secupdateContent.content.arrTradeInSerials.length : 0) * 30 + this.TABLE_HEADER_PLUS_EXTRA_HEIGHT;
    if (height > this.TABLE_MAX_HEIGHT) {
      height = this.TABLE_MAX_HEIGHT;
    }
    return `${height}px`;
  }

  get showTz80SecureUpgradeNote() {
    const { isTz80 = '', issecureupgrade = false } = this.secupdateContent?.content || {};
    return isTz80 === 'YES' && issecureupgrade;
  }

  get secureRegisterOption(): SelectOption[] {
    if (this.isSMA100TradeUp) {
      this.secureRegisterOptionsArray[0].label = this.$t('products.registerTradeupDecommission').toString();
      return [this.secureRegisterOptionsArray[0]];
    }
    return this.secureRegisterOptionsArray;
  }

  get isSMA100TradeUp() {
    return this.secUpdatePage === 'REPLACEMENTTYPE:SMA100TRADEUP';
  }

  validateRegex = (ele: any) => {
    const regexStr = new RegExp(ele?.regexValidation);
    return regexStr?.test(ele?.value);
  }

  confirm() {
    let secureUpdateData : any ;
    secureUpdateData = [];
    if (!this.acceptAcknowledgement && (this.secUpdatePage === 'REPLACEMENTTYPE:SECUREUPGRADEPLUS' || this.secUpdatePage === 'REPLACEMENTTYPE:SNWLTRADEIN' || this.isSMA100TradeUp)) {
      const message: InfoState = { infoType: 'failed', infoMsg: (this.$t('products.readTermsAndCondition')
      .toString()) };
      this.$store.commit('enqueueMessage', message);
      return;
    }
    if (this.secUpdatePage === 'REPLACEMENTTYPE:SECUREUPGRADEPLUS') {
      this.$v!.answer!.$touch();
      if (!this.$v!.answer!.checkForEmpty) {
        for (const ele of this.answer) {
          if (!this.validateRegex(ele)) {
            // tslint:disable-next-line
            const errorToDisplay = `${this.$t('common.invalid').toString()} ${ele?.question.replace(/[:*]/g, '')}`;
            const message: InfoState = { infoType: 'failed', infoMsg: errorToDisplay };
            this.$store.commit('enqueueMessage', message);
            return;
          }
        }
        // tslint:disable-next-line:no-unused
        this.secupdateContent.content.arrCompetitiveSurvey.forEach((element: any, index : any) => {
          const inner :any = {};
          inner['questionID'] = element.questionID;
          inner['questionAnswer'] = this.answer[index].value.trim();
          secureUpdateData.push(inner);
        });
        // tslint:disable-next-line:max-line-length
        this.$store.commit('MswProductsStoreModule/mapMutate', { property: 'registerOrTransfer', key: this.field , value: true });
        this.$store.commit('MswProductsStoreModule/mapMutate', { property: 'secureUpgrade', key : this.field , value : secureUpdateData });
        this.$emit('secureUpdateSerialNumber', secureUpdateData[2].questionAnswer);
        this.$store.commit('MswProductsStoreModule/mutate', { property: 'secureUpdateData', with: secureUpdateData });
        this.closeProductDetail();
      }
    } else if ((this.secUpdatePage === 'REPLACEMENTTYPE:SNWLTRADEIN' || this.isSMA100TradeUp) && this.tradeInKey !== '') {
      if (this.secureRegister === '2') {
        this.customMessagePopupConfig = {
          msgType: 'major',
          msgText: `${this.$t('products.secureUpgradeNote')}`,
          nonDefaultButtonText: 'Cancel',
          defaultButtonText: 'Confirm',
          width:'50',
        };
        this.showCustomMessagePopup = true;
      } else {
        const inner: any = {};
        inner['tradeInSerialnumber'] = this.secupdateContent.content.arrTradeInSerials[this.tradeInKey].serialnumber;
        secureUpdateData.push(inner);
        const secureUpdateData1 = this.$store.getters['MswProductsStoreModule/getSecureUpgrade'];
        let flag = 0;
        for (let i = 1; i < secureUpdateData1.size + 1 ; i = i + 1) {
          if (!(secureUpdateData1.get(i) === '' || secureUpdateData1.get(i) === undefined)) {
            if (secureUpdateData1.get(i)[0].tradeInSerialnumber === secureUpdateData[0].tradeInSerialnumber && i !== this.field) {
              flag = 1;
              const message: InfoState = { infoType: 'failed', infoMsg: (this.$t('products.selectedUTM')
              .toString()) };
              this.$store.commit('enqueueMessage', message);
              // this.closeProductDetail();
            }
          }
        }
        if (flag === 0) {
          // tslint:disable-next-line:max-line-length
          this.$store.commit('MswProductsStoreModule/mapMutate', { property: 'registerOrTransfer', key: this.field , value: this.secureRegister === '2' ? false : true });
          this.$emit('secureUpdateSerialNumber', secureUpdateData[0].tradeInSerialnumber);
          this.$store.commit('MswProductsStoreModule/mapMutate', { property: 'secureUpgrade', key : this.field , value : secureUpdateData });
          this.$store.commit('MswProductsStoreModule/mutate', { property: 'secureUpdateData', with: secureUpdateData });
          this.closeProductDetail();
        }
      }
    } else if (this.secUpdatePage === 'Storage Module') {
      const inner: any = {};
      inner['storageModuleParentSerialnumber'] = this.secupdateContent.content.arrStorageModuleParentSerials[this.tradeInKey].serialnumber;
      secureUpdateData.push(inner);
      const secureUpdateData1 = this.$store.getters['MswProductsStoreModule/getStorageSata'];
      let flag = 0;
      for (let i = 1; i < secureUpdateData1.size + 1 ; i = i + 1) {
        if (!(secureUpdateData1.get(i) === '' || secureUpdateData1.get(i) === undefined)) {
          if (secureUpdateData1.get(i)[0].storageModuleParentSerialnumber === secureUpdateData[0].storageModuleParentSerialnumber) {
            flag = 1;
            const message: InfoState = { infoType: 'failed', infoMsg: (this.$t('products.selectedUTM')
            .toString()) };
            this.$store.commit('enqueueMessage', message);
            // this.closeProductDetail();
          }
        }
      }
      if (flag === 0) {
        this.$emit('secureUpdateSerialNumber', secureUpdateData[0].storageModuleParentSerialnumber);
        this.$store.commit('MswProductsStoreModule/mapMutate', { property: 'storageSata', key : this.field , value : secureUpdateData });
        this.$store.commit('MswProductsStoreModule/mutate', { property: 'secureUpdateData', with: secureUpdateData });
        this.closeProductDetail();
      }
    } else if (this.secUpdatePage === 'Upgrade Serial Number') {
      this.$emit('secureUpdateSerialNumber', this.secupdateContent.content.arrTradeInSerials[this.tradeInKey].serialnumber);
      // tslint:disable-next-line:max-line-length
      this.$store.commit('MswProductsStoreModule/mapMutate', { property: 'freeTrailSerNo', key : this.field , value : this.secupdateContent.content.arrTradeInSerials[this.tradeInKey].serialnumber });
      const secureUpdateData1 = this.$store.getters['MswProductsStoreModule/getFreeTrailSerNo'];
      console.error(secureUpdateData1);
      this.closeProductDetail();
    }
  }

  onSingleSelectEntry(data: TableEntrySelectingEventData) {
    this.tradeInKey = data.entryKey;
    const ssipnProgram = this.secupdateContent?.content?.arrTradeInSerials[data?.entryKey]?.ssipnProgram;
    if (data.selecting) {
      const { warningText = '' } = this.secupdateContent?.content?.arrTradeInSerials[data?.entryKey] || {};
      this.infoText = this.secupdateContent?.content?.arrTradeInSerials[data?.entryKey]?.infoText || '';
      if (ssipnProgram === 'SECAASV1') {
        const message: InfoState = { infoType: 'major', infoMsg: (this.$t('products.secaasv1Alert')
        .toString()) };
        this.$store.commit('enqueueMessage', message);
        this.changeDropdownOption(0);
      } else if (ssipnProgram === 'SECAASV2') {
        const message: InfoState = { infoType: 'major', infoMsg: (this.$t('products.secaasv2Alert')
        .toString()) };
        this.$store.commit('enqueueMessage', message);
        this.changeDropdownOption(0);
      } else {
        this.changeDropdownOption(1);
      }
      if (warningText) {
        const message: InfoState = { infoType: 'major', infoMsg: warningText };
        this.$store.commit('enqueueMessage', message);
      }
    }
  }

  // 0- Decommission 1- Transfer
  changeDropdownOption(val: number) {
    this.secureRegisterOptionsArray = this.secureRegisterOptionsArray.map((ele: any) => {
      return ele?.id === '2' ? { ...ele, label: val === 0 ? this.$t('products.registerDecommission')
        .toString() : this.$t('products.registerTransfer')
        .toString() } : ele;
    });
  }

  onProcessSecureUpgrade() {
    let secureUpdateData : any ;
    secureUpdateData = [];
    const inner: any = {};
    inner['tradeInSerialnumber'] = this.secupdateContent.content.arrTradeInSerials[this.tradeInKey].serialnumber;
    secureUpdateData.push(inner);
    const secureUpdateData1 = this.$store.getters['MswProductsStoreModule/getSecureUpgrade'];
    let flag = 0;
    for (let i = 1; i < secureUpdateData1.size + 1 ; i = i + 1) {
      if (!(secureUpdateData1.get(i) === '' || secureUpdateData1.get(i) === undefined)) {
        if (secureUpdateData1.get(i)[0].tradeInSerialnumber === secureUpdateData[0].tradeInSerialnumber && i !== this.field) {
          flag = 1;
          const message: InfoState = { infoType: 'failed', infoMsg: (this.$t('products.selectedUTM')
          .toString()) };
          this.$store.commit('enqueueMessage', message);
          // this.closeProductDetail();
        }
      }
    }
    if (flag === 0) {
      // tslint:disable-next-line:max-line-length
      this.$store.commit('MswProductsStoreModule/mapMutate', { property: 'registerOrTransfer', key: this.field , value: this.secureRegister === '2' ? false : true });
      this.$emit('secureUpdateSerialNumber', secureUpdateData[0].tradeInSerialnumber);
      this.$store.commit('MswProductsStoreModule/mapMutate', { property: 'secureUpgrade', key : this.field , value : secureUpdateData });
      this.$store.commit('MswProductsStoreModule/mutate', { property: 'secureUpdateData', with: secureUpdateData });
      const secureUpdateData2 = this.$store.getters['MswProductsStoreModule/getSecureUpgrade'];
      console.error(secureUpdateData2);
      this.closeProductDetail();
    }
  }

  wrapperWidth: any = '50%';

  getResizedLayout() {
    if (window?.innerWidth <= 2100) {
      this.wrapperWidth = '50%';
    }
    if (window?.innerWidth <= 1850) {
      this.wrapperWidth = '60%';
    }
    if (window?.innerWidth <= 1600) {
      this.wrapperWidth = '70%';
    }
    if (window?.innerWidth <= 1400) {
      this.wrapperWidth = '80%';
    }
    if (window?.innerWidth <= 1250) {
      this.wrapperWidth = '90%';
    }
  }

  created() {
    window?.addEventListener('resize', this.getResizedLayout);
    this.$store.commit('MswProductsStoreModule/mutate', { property: 'secureUpdateData', with: '' });
    if (this.secUpdatePage === 'REPLACEMENTTYPE:SECUREUPGRADEPLUS') {
      this.secupdateContent.content.arrCompetitiveSurvey.forEach((element : any) => {
        this.answer.push({
          id: element?.questionID,
          type: element?.questionType,
          question: element?.question,
          isMandatory: element?.isMandatory,
          regexValidation: element?.regexValidation,
          value : '',
        });
        if (element.questionType === 'LIST') {
          // const inner : any = {};
          // inner['id'] = 'default';
          // inner['label'] = 'Please specify Manufacturer, Model Name or Number :';
          // inner['value'] = 'Please specify Manufacturer, Model Name or Number :';
          // this.choiceListOpt.push(inner);
          element.arrChoices.forEach((ele : any) => {
            const inner : any = {};
            inner['id'] = ele.choiceval;
            inner['label'] = ele.choicetext;
            inner['value'] = ele.choicetext;
            this.choiceListOpt.push(inner);
          });
          this.answer[1].value =  this.choiceListOpt[0].id;
        }
      });
    } else if (this.secUpdatePage === 'REPLACEMENTTYPE:SNWLTRADEIN' || this.isSMA100TradeUp) {
      this.tableData = [];
      this.secupdateContent?.content?.arrTradeInSerials?.forEach((element: any , index : any) => {
        this.tableData.push({
          _key: index.toString(),
          done: true,
          name: element.name,
          serialnumber: element.serialnumber,
          productline: element.productLine === '' ? '--' : element.productLine,
          expiration: element.expirationDate === '' ? '--' : element.expirationDate,
          registration: element.registrationCode === '' ? '--' : element.registrationCode,
          nodeUpgrade: element?.nodeUpgrade === '' ? '--' : element?.nodeUpgrade,
        });
      });
    } else if (this.secUpdatePage === 'Storage Module') {
      this.tableData = [];
      this.secupdateContent.content.arrStorageModuleParentSerials.forEach((element: any , index : any) => {
        this.tableData.push({
          _key: index.toString(),
          done: true,
          name: element.name,
          serialnumber: element.serialnumber,
          productline: element.productLine === '' ? '--' : element.productLine,
        });
      });
    } else if (this.secUpdatePage === 'Upgrade Serial Number') {
      this.tableData = [];
      this.secupdateContent.content.arrTradeInSerials.forEach((element: any , index : any) => {
        this.tableData.push({
          _key: index.toString(),
          done: true,
          serialnumber: element.serialnumber,
          frielndlyname: element.friendlyName,
        });
      });
    }
    // else if (this.secUpdatePage === 'REPLACEMENTTYPE:REMOTEANALYZER') {
    //   this.remoteAnalyser = this.secupdateContent.content.termsConditions;
    //   this.remoteAnalyser.replace(/\n/ig, '<br>');
    // }
  }
  onRequestSorting(data: ColumnSortRequestData) {
    const index = this.sortedColumns.findIndex(col => (col.colKey === data.colKey));
    if (index < 0) {
      if (data.cancel) { return; }
      this.sortedColumns.splice(0);
      this.sortedColumns.push({
        colKey: data.colKey,
        ascending: !!data.ascending,
      });
    } else {
      if (data.cancel) {
        this.sortedColumns.splice(index, 1);
        return;
      }
      this.sortedColumns[index].ascending = !!data.ascending;
    }
  }
  handleSearchFilter() {
    this.filteredTableData = this.tableData.filter((ele : any) => {
      if (ele.name.toLowerCase()
      .indexOf(this.searchInputText.toLowerCase()) > -1 || ele.serialnumber.toLowerCase()
      .indexOf(this.searchInputText.toLowerCase()) > -1) {
        return ele;
      }
    });
    this.filterApplied = true;
  }
  mutateFilterState(event : any) {
    this.filterApplied = false;
    this.filteredTableData = [];
    this.searchInputText = '';
    console.error(event);
  }
  get getShowCustomMessagePopup() {
    return this.showCustomMessagePopup;
  }
  closeCustomMessagePopup() {
    this.showCustomMessagePopup = false;
  }
  onInputValue(index: number, event: any) {
    this.answer[index] = event;
  }

  beforeDestroy() {
    window?.removeEventListener('resize', this.getResizedLayout);
  }
}
